var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GlobalGoals"},[_c('ul',{staticClass:"GlobalGoals__items"},_vm._l((_vm.goals),function(goal){return _c('li',{key:goal},[_c('img',{attrs:{"src":("/images/globalgoals/Goal-" + goal + ".svg")}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }